<template>
  <el-dialog
      :visible.sync="visible"
      title="选择发货单"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
      :append-to-body="true"
  >
    <ReceiveTable ref="ReceiveTable" :opt-type="type" :status="30" :show-status-query="false" :height="500"
                  :selection="true" :show-selection-btn="true" @selected="selectedHandler"></ReceiveTable>
  </el-dialog>
</template>

<script>
import ReceiveTable from '@/views/modules/erp/receive/receive-table.vue'

export default {
  mixins: [],
  components: { ReceiveTable },
  data () {
    return {
      visible: false,
      type: 10,
    }
  },
  watch: {},
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.ReceiveTable.reload()
      })
    },
    selectedHandler (data) {
      this.$emit('selected', data)
      this.visible=false
    }
  },
}
</script>

<style lang="scss" scoped>
.count-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;
}
</style>


